import styled, { keyframes } from 'styled-components';
import { Colors } from './../../../ui';

const toastIn = keyframes`
    from {
        opacity: 0;
        transform: scale3d(.3, .3, .3);
    }
    50% {
        opacity: 1;
    }
`;

const toastOut = keyframes`
    from {
        opacity: 1;
    }
    50% {
        opacity: 0;
        transform: scale3d(.3, .3, .3);
    }
    to {
        opacity: 0;
    }
`;

export const ToastTheme = styled.div`
    
    .toastIn {
        animation: ${toastIn} cubic-bezier(.21,.98,.2,1.14);        
    }
    
    .toastOut {
        animation: ${toastOut} cubic-bezier(.21,.98,.2,1.14);
    }

    .toastAnimate {
        animation-duration: 300ms;
    }

    .Toastify__toast-container {
        right: 5rem;
        bottom: 0.4rem;
    }

    .Toastify__toast {
        position: relative;
        min-height: 4rem;
        box-sizing: border-box;
        margin-bottom: .5rem;
        padding: .5rem;
        border-radius: 0.4rem;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2), 0 15px 15px 0 rgba(0, 0, 0, 0.05);
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        cursor: pointer;
        direction: ltr;
        font-weight: 420;
        font-family: 'Inter';
        backface-visibility: hidden;
        -webkit-font-smoothing: subpixel-antialiased;

        &--success {
            border-left: solid 5px ${Colors.positive};
            color: #515566;
            background: white;

            .toast-icon {
                color: ${Colors.positive};
            }
        }

        &--info {
            border-left: solid 5px ${Colors.primary};
            color: #515566;
            background: white;

            .toast-icon {
                color: ${Colors.primary};
            }
        }

        &--warning {
            border-left: solid 5px ${Colors.observe};
            color: #515566;
            background: white;

            .toast-icon {
                color: ${Colors.observe};
            }
        }

        &--error {
            border-left: solid 5px ${Colors.negative};
            color: #515566;
            background: white;

            .toast-icon {
                color: ${Colors.negative};
            }
        }
    }

    .Toastify__close-button {
        color: gray;
        font-size: .875rem;
        margin: 0.4rem 0.4rem 0;
    }
`;
